<template>
  <view-wrapper
    :show-back-button="true"
    name="QualityAssurance - Publish view"
    path="qa/labels"
    back-text="Back to labels list"
    :loading="loading"
    loading-text="Loading QualityAssuranceLabelDetails">

    <div class="float-right font-semibold">
      <span v-if="!!message">
        {{message}}
      </span>
    </div>

    <wrapper class="mb-3 p-5" >
      <h2>Approvers</h2>
      <div v-if="labelDesigners && labelDesigners.length > 0">
        <hr />
        <div>
          <checkbox :value="labelDesigners.length > 0 && labelDesigners.length == labelDesigners.filter((d) => d.approvalStatus === 'Approved').length" />
          <span class="ml-2">Designer</span>
          <div class="ml-4" v-for="(designer, index) in labelDesigners" :key="index">
            <p>{{designer.approverName}} <small>{{designer.approverRole}}</small> <small> {{designer.approvalStatus}}</small></p>
          </div>
        </div>
        <hr />
        <div>
          <checkbox :value="designApprovers.length > 0 && designApprovers.length == designApprovers.filter((d) => d.approvalStatus === 'Approved').length" />
          <span class="ml-2">Design approvers</span>
          <div class="ml-4" v-for="(design, index) in designApprovers" :key="index">
            <p>{{design.approverName}} <small>{{design.approverRole}}</small> <small> {{design.approvalStatus}}</small></p>
          </div>
        </div>
        <hr />
        <div>
          <checkbox :value="dataApprovers.length > 0 && dataApprovers.length == dataApprovers.filter((d) => d.approvalStatus === 'Approved').length" />
          <span class="ml-2">Data approvers</span>
          <div class="ml-4" v-for="(data,index) in dataApprovers" :key="index">
            <p>{{data.approverName}} <small>{{data.approverRole}}</small> <small> {{data.approvalStatus}}</small></p>
          </div>
        </div>
      </div>

    </wrapper>

    <AuthorizationZone allowAny="QualityAssuranceRole:Publisher" >
      <grafokett-button class="big ml-2 bg-primary text-textcolor" @click="modalPublish = !modalPublish">PUBLISH</grafokett-button>
    </AuthorizationZone>

    <modal
    v-if="modalPublish"
    @close="modalPublish = !modalPublish"
    type="primary"
    :heading="'Publish!'"
    :description="`Are you sure you want to publish?.`"
    >
      <template slot="body" >
        <div class="my-3 p-4 bg-primary-light">
          <label class="text-lg" >Description</label>
          <comment-box placeholderText="Describe the changes being published" class="my-2" v-model="commentText" />
        </div>
      </template>
      <template slot="buttons" >
        <div>
          <grafokett-button
            type="primary"
            class="big bg-white border-primary text-primary"
            @click="onPublish"
          >Yes, publish</grafokett-button
          >
          <grafokett-button
            class="big ml-2 bg-primary text-textcolor"
            @click="modalPublish = !modalPublish"
          >Go back</grafokett-button
          >
        </div>
      </template>
    </modal>

    <modal
    @close="publishSuccessful = !publishSuccessful"
    v-if="publishSuccessful"
    :type="'success'"
    :heading="'Publish successful!'"
    >
      <template slot="buttons" >
        <div>
          <grafokett-button
            :type="'success'"
            class="big bg-white border-primary text-primary"
            @click="goToDetails"
          >Go to details</grafokett-button
          >
        </div>
      </template>
    </modal>

    <modal
    v-if="publishError"
    @close="publishError = !publishError"
    :type="'error'"
    :heading="'Publish not successful!'"
    :description="'Something went wrong, could not publish changes.'"
    >
      <template slot="buttons" >
        <div>
          <grafokett-button
            :type="'error'"
            class="big bg-white border-primary text-primary"
            @click="onError"
          >Close</grafokett-button
          >
        </div>
      </template>
    </modal>

  </view-wrapper>
</template>

<script>

import GrafokettButton from '../../../components/forms/Button.vue';
import Checkbox from 'components/forms/Checkbox';
import Modal from 'components/Modal';
import AuthorizationZone from "../../../components/AuthorizationZone";
import CommentBox from "components/CommentBox";


export default {
  components: {
    CommentBox,
    GrafokettButton,
    Checkbox,
    Modal,
    AuthorizationZone
  },
  data: () => ({
    loading: false,
    message: "",
    reviewers: [
      {timestamp: '2021-03-03', permission: 'DataApprover', email: 'dataApprover@mail.com', approved: true},
      {timestamp: '2021-03-03', permission: 'DesignApprover', email: 'designApprover@mail.com', approved: true},
    ],
    labelData: null,
    modalPublish: false,
    publishSuccessful: false,
    publishError: false,
    commentText: ''
  }),
  computed: {
    title () {
      return 'QualityAssuranceLabelDetails'
    },
    labelVersion () {
      var label = this.labelData;
      if(!label)
        return [];

      const labelVersion = label.versions && label.versions.find(v => v.labelVersionId == this.$route.params.versionId);

      return labelVersion
    },
    labelDesigners() {
     const labelVersion = this.labelVersion;
      if(!labelVersion)
        return [];

      return labelVersion.approvals.filter(r => r.approverRole === 'LabelDesigner' && r.approvalStatus !== 'Inactive')
    },
    designApprovers() {
     const labelVersion = this.labelVersion;
      if(!labelVersion)
        return [];

      return labelVersion.approvals.filter(r => r.approverRole === 'DesignApprover' && r.approvalStatus !== 'Inactive')
    },
    dataApprovers() {

     const labelVersion = this.labelVersion;
      if(!labelVersion)
        return [];
      return labelVersion.approvals.filter(r => r.approverRole === 'DataApprover' && r.approvalStatus !== 'Inactive')
    }
  },
  methods: {
    async getData () {
      this.loading = true;
      const response = await this.$store.$api.get(`/api/QualityAssurance/getLabelInfo/${this.$route.params.labelId}`);
      this.labelData = response.data;
      this.loading = false;
    },
    async onPublish() {
      try {
        this.loading = true
        const payload = {
          labelId: this.$route.params.labelId,
          labelVersionId: this.$route.params.versionId,
          comment: this.commentText
        }
        const response = await this.$store.dispatch('QUALITY_ASSURANCE/PUBLISH', payload)
        if(response.data.success) {
          this.publishSuccessful = true
        } else {
          this.publishError = true
          this.modalPublish = !this.modalPublish
        }
        this.loading = false
      } catch (error) {
        this.publishSuccessful = false
        this.publishError = true
        this.loading = false
        throw error
      }
    },
    goToDetails() {
      this.$router.push(`/qa/labels/${this.$route.params.labelId}/details`)
    },
    onError() {
      this.publishError = !this.publishError
    }
  },
  async mounted () {
    await this.getData();
  }
}
</script>
